export const sections = {
  Login: 1,
  Summary: 100,
  MyProducts: 200,
  Incidences: 600,
  Information: 900,
  Help: 1200,
  MyAccount: 1000
}

export const pages = {
  Login: 1,
  Summary: 100,
  Webshop: 200,
  Checkout: 300,
  Catalog: 600,
  List: 700,
  Reports: 800,
  Data: 1400,
  PointOfSale: 1500,
  Contact: 1700
}

export const events = {
  UserLogin: 1,
  UserClickAdvertisingSummary: 101,
  UserClickAdvertisingWebshop: 201,
  UserAddListSuggestedProducts: 205,
  UserAddProductYouMightAlsoLike: 207,
  UserAccessSectionCatalog: 208,
  UserCreateNewIncidence: 602,
  UserRequestChangeData: 1001,
  UserSelectPOS: 1002,
  UserAccessSectionReports: 1100,
  UserAccessContactUsSection: 1201,
  UserSendMessage: 1202
}
